import React from "react";
import { useNavigate } from "react-router-dom";
import dashboardMobileIcon from "../../../Assets/m-dashboard-icon.svg";
import dashactivemobile from "../../../Assets/dashactivemobile.svg";
import aiLeadsMobileIcon from "../../../Assets/m-aileads-icon.svg";
import aileadactivemobile from "../../../Assets/aileadactivemobile.svg";
import aiprospectmobile from "../../../Assets/aiprospectmobile.svg";
import aiProspectMobileIcon from "../../../Assets/m-aiprospect-icon.svg";
import aiPathMobileIcons from "../../../Assets/m-aipath-icon.svg";
import aipathmobile from "../../../Assets/aipathmobile.svg";
import moreMobileIcon from "../../../Assets/m-more-icon.svg";
import chaticonmobilewhite from "../../../Assets/chaticonmobilewhite.svg";
import chaticonatasmb from "../../../Assets/chaticonatasmb.svg";
import AtlasIconSelect from "../../../Assets/AtlasIconSelect.svg"
import atlasimobileinactive from "../../../Assets/atlasimobileinactive.svg"
import "../MobileResponsive.css";
import {
  AI_DECISION_MAKER,
  AI_LEADS,
  AI_PATH,
  DASHBOARD,
  ATLAS_CHAT,
} from "../../../Utils/Constants";
import aiLeadsMobile from "../../../Assets/aiLeadsMobile.svg";
import aiLeadsMobileActive from "../../../Assets/aiLeadsMobileActive.svg";
const MFooter = ({ setOpen }) => {
  const navigate = useNavigate();

  return (
    <div className="mobile-footer-main-outer">
      <div className="mobile-screens-footer-main">
        {window.location.pathname === DASHBOARD ? (
          <div
            className="mobile-screens-footer-inner-active"
            onClick={() => navigate("/dashboard")}
          >
            <div className="icon-mobile-screens">
              <img src={dashactivemobile} alt="Dashboard" />
            </div>
            <p>Dashboard</p>
          </div>
        ) : (
          <div
            className="mobile-screens-footer-inner"
            onClick={() => navigate("/dashboard")}
          >
            <div className="icon-mobile-screens">
              <img src={dashboardMobileIcon} alt="Dashboard" />
            </div>
            <p>Dashboard</p>
          </div>
        )}
        {window.location.pathname === ATLAS_CHAT ? (
          <div
            className="mobile-screens-footer-inner-active"
            onClick={() => navigate("/atlas-chat")}
          >
            <div className="icon-mobile-screens">
              <img src={chaticonatasmb} alt="Chat" />

            </div>
            <p>Atlas Chat</p>
          </div>
        ) : (
          <div
            className="mobile-screens-footer-inner"
            onClick={() => navigate("/atlas-chat")}
          >
            <div className="icon-mobile-screens">
              <img src={atlasimobileinactive} alt="Chat" />

            </div>
            <p>Atlas Chat</p>
          </div>
        )}
        {window.location.pathname === AI_LEADS ? (
          <div
            className="mobile-screens-footer-inner-active"
            onClick={() => navigate("/aileads")}
          >
            <div className="icon-mobile-screens">
              {/* <img src={aileadactivemobile} alt="Ai Leads" /> */}
              <img src={aiLeadsMobileActive} alt="Ai Leads" />
            </div>
            <p>AI Leads</p>
          </div>
        ) : (
          <div
            className="mobile-screens-footer-inner"
            onClick={() => navigate("/aileads")}
          >
            <div className="icon-mobile-screens">
              {/* <img src={aiLeadsMobileIcon} alt="Ai Leads" /> */}
              <img src={aiLeadsMobile} alt="Ai Leads" />
            </div>
            <p>AI Leads</p>
          </div>
        )}
        {window.location.pathname === AI_DECISION_MAKER ? (
          <div
            className="mobile-screens-footer-inner-active"
            onClick={() => navigate(AI_DECISION_MAKER)}
          >
            <div className="icon-mobile-screens">
              <img src={aiprospectmobile} alt="Ai Prospects" />
            </div>
            <p>AI Prospects</p>
          </div>
        ) : (
          <div
            className="mobile-screens-footer-inner"
            onClick={() => navigate(AI_DECISION_MAKER)}
          >
            <div className="icon-mobile-screens">
              <img src={aiProspectMobileIcon} alt="Ai Prospects" />
            </div>
            <p>AI Prospects</p>
          </div>
        )}
        {/* {window.location.pathname === AI_PATH ? (
          <div
            className="mobile-screens-footer-inner-active"
            onClick={() => navigate("/aipath")}
          >
            <div className="icon-mobile-screens">
              <img src={aipathmobile} alt="Ai Path" />
            </div>
            <p>Ai Path</p>
          </div>
        ) : (
          <div
            className="mobile-screens-footer-inner"
            onClick={() => navigate("/aipath")}
          >
            <div className="icon-mobile-screens">
              <img src={aiPathMobileIcons} alt="Ai Path" />
            </div>
            <p>Ai Path</p>
          </div>
        )} */}

        <div
          className="mobile-screens-footer-inner"
          onClick={() => setOpen((prev) => !prev)}
        >
          <div className="icon-mobile-screens">
            <img src={moreMobileIcon} alt="More" />
          </div>
          <p>More</p>
        </div>
      </div>
    </div>
  );
};

export default MFooter;
